<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button *ngIf="toShowEmployees" (click)="hideEmployee()">
      <mat-icon>close</mat-icon>
    </button>
    <button mat-icon-button mat-dialog-close *ngIf="!toShowEmployees">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content *ngIf="!toShowEmployees">
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="newbookingData.customerName" matInput />
        
      </mat-form-field>
    </div>
    <!-- <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
        maxlength="10"/>
        
      </mat-form-field>
    </div> -->
    <div class="row g-2  justify-content-between phone-field">
      <mat-form-field appearance="outline" class="country-code col-3">
        <mat-label>Country Code</mat-label>
        <mat-select
        [(ngModel)]="selectedCountryCode"
        required
        (selectionChange)="onCountrySelected($event)"
      >
        <mat-select-trigger>
          {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
              {{ "(" + selectedCountryCode.dial_code + ")" }}
        </mat-select-trigger>
        
        <mat-option>
          <ngx-mat-select-search
            noEntriesFoundLabel="no results found"
            name="countrysearch"
            placeholderLabel="Enter country name"
            [formControl]="searchString"
            (keyup)="onKey()"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let country of countryList" [value]="country">
          {{ country.flag }} {{ country.name }}
          {{ "(" + country.dial_code + ")" }}
        </mat-option>
      </mat-select>
      </mat-form-field>
      <mat-form-field class="mobile_form col-9" appearance="outline" >
        <mat-label>Phone</mat-label>
        <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
        minLength="3"
                  maxlength="17">
        <mat-hint style="color: red;
    font-size: 13px;" align="end" *ngIf="newbookingData.customerPh && newbookingData.customerPh != '' &&  newbookingData.customerPh.length < 3 ">Please enter a valid phone number in the range of 3-17.</mat-hint>
      </mat-form-field>
    </div>
    <div style="padding-left: 5px;">
      <h3 style="margin-bottom:5px">Opted services</h3>
      <div style="color: #f2b600;
      font-weight: 500;
      font-size: 16px;">
        <p>{{parentData.data.bookingData.serviceInfo | servicesToStr}}</p>
      </div>
    </div>
    <div class="chip_cont" style="padding: 20px 0px;">
      <mat-chip-list class="example-chip" *ngIf="serviceList.length > 0">
        <div *ngFor="let item of serviceList">
          <mat-chip
            *ngIf="item.toShow"
            style="height: auto"
            (click)="selectServices(item)"
            >{{ item.serviceName }}
          </mat-chip>
        </div>
     

      </mat-chip-list>
      <p *ngIf="serviceList.length == 0">No service added</p>
      </div>

<!-- PRODUCTS LIST -->
<div class="chip_cont" style="padding: 20px 0px;" *ngIf="productsList.length > 0">
  <h3>Sellable products</h3>
  <mat-chip-list class="example-chip" *ngIf="productsList.length > 0">
    <div *ngFor="let item of productsList">
      <mat-chip
        *ngIf="item.toShow"
        style="height: auto"
        (click)="selectProducts(item)"
        >{{ item.product_name }}
      </mat-chip>
    </div>
 

  </mat-chip-list>
  <p *ngIf="productsList.length == 0">No product added</p>
  </div>

      <!-- JOB COMPLETED -->

      <h3 *ngIf="completedJobs.length > 0">Job completed</h3>
    <div class="chip_cont">
      <div class="" *ngIf="completedJobs.length > 0">
        <!-- <mat-chip-list aria-label="Fish selection" class="mb-3">
              <mat-chip
                style="height: auto"
                class="selected"
          *ngFor="let item of selectedJobs"
                >{{item.serviceName}}
                <mat-icon matChipRemove (click)="removeSelectedJobs(item)" style="color: red;
                opacity: 1;">cancel</mat-icon>
              </mat-chip>
            </mat-chip-list> -->
        <div *ngFor="let item of completedJobs; let i = index;" style="margin-bottom: 30px;display: flex;
        justify-content: space-between;
        align-items: center;">
          <div class="first_div">
            <div
              
              style="
                display: inline-block;
                width: fit-content;
                background: #ffc107;
                padding: 8px 20px;
                border-radius: 34px;
                margin-bottom: 20px;
              "
            >
              <p style="margin: 0px; font-weight: 500; font-size: 16px">
                {{ item.service_name }}
              </p>
            </div>
            <mat-icon style="    font-size: 20px;
            font-weight: 900;
            color: #000;
            position: relative;
            top: 4px;
            margin-left: 10px;">close</mat-icon>
            <div style="display: inline-block;">
              <span style="    margin-left: 10px;
              border: 1px solid #a2a2a2;
              padding: 10px;
              border-radius: 10px;">
                <button
                (click)="decreaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;">remove</mat-icon>
                </button>
                <span style="    margin: 0 15px;"> {{item.total_completed_services_qty}} </span>
                <button 
                (click)="increaseServiceCount(item,i)"
                style="background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;">
                <mat-icon style="    font-size: 16px;
                position: relative;
                top: 2px;
                left: -3px;
                color: #666666;
                height: auto;
                width: auto;" class="material-icons-outlined">add</mat-icon>
                </button>
              </span>
              
              
            </div>
            <div style="
              text-decoration: underline; cursor: pointer;">
                by <span (click)="assignEmployee(item,i)" >{{item.completed_by | arrayToStr | ellipsify:30}}</span>
  
              <span
              (click)="removeCompletedJobs(item)"
              style="
              margin-left: 20px;
              display: inline-block;
              cursor: pointer;">
                Remove
              </span>
              </div>

          </div>
          <div class="second-div" style="padding: 0;">

            <div >
              <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                <!-- <mat-label>Price</mat-label> -->
                <input [(ngModel)]="item.price" matInput smDecimalOnly type="number"  (ngModelChange)="changeServicePrice(item)"/>
                <!--  -->
              </mat-form-field>
            </div>
        </div>

        </div>
      </div>
        

      </div>


      <!-- PRODUCTS COMPLETED -->
      <h3 *ngIf="completedProducts.length > 0">Products selected</h3>
      <div class="chip_cont">
        <div class="" *ngIf="completedProducts.length > 0">
          <!-- <mat-chip-list aria-label="Fish selection" class="mb-3">
                <mat-chip
                  style="height: auto"
                  class="selected"
            *ngFor="let item of selectedJobs"
                  >{{item.serviceName}}
                  <mat-icon matChipRemove (click)="removeSelectedJobs(item)" style="color: red;
                  opacity: 1;">cancel</mat-icon>
                </mat-chip>
              </mat-chip-list> -->
          <div *ngFor="let item of completedProducts; let i = index;" style="margin-bottom: 30px;display: flex;
          justify-content: space-between;
          align-items: center;">
            <div class="first_div">
              <div
                
                style="
                  display: inline-block;
                  width: fit-content;
                  background: #ffc107;
                  padding: 8px 20px;
                  border-radius: 34px;
                  margin-bottom: 20px;
                "
              >
                <p style="margin: 0px; font-weight: 500; font-size: 16px">
                  {{ item.product_name }}
                </p>
              </div>
              <mat-icon style="    font-size: 20px;
              font-weight: 900;
              color: #000;
              position: relative;
              top: 4px;
              margin-left: 10px;">close</mat-icon>
              <div style="display: inline-block;">
                <span style="    margin-left: 10px;
                border: 1px solid #a2a2a2;
                padding: 10px;
                border-radius: 10px;">
                  <button
                  (click)="decreaseProductCount(item,i)"
                  style="background: none;
                  border: 1px solid #a2a2a2;
                  border-radius: 25px;
                  width: 25px;
                  height: 25px;">
                  <mat-icon class="material-icons-outlined" style="    font-size: 16px;
                  position: relative;
                  top: 2px;
                  left: -3px;
                  color: #666666;
                  height: auto;
                  width: auto;">remove</mat-icon>
                  </button>
                  <span style="    margin: 0 15px;"> {{item.product_qty}} </span>
                  <button 
                  (click)="increaseProductCount(item,i)"
                  style="background: none;
                  border: 1px solid #a2a2a2;
                  border-radius: 25px;
                  width: 25px;
                  height: 25px;">
                  <mat-icon style="    font-size: 16px;
                  position: relative;
                  top: 2px;
                  left: -3px;
                  color: #666666;
                  height: auto;
                  width: auto;" class="material-icons-outlined">add</mat-icon>
                  </button>
                </span>
                
                
              </div>
              <div style="
                text-decoration: underline; cursor: pointer;">
                  <!-- by <span (click)="assignEmployee(item,i)" >{{item.completed_by | arrayToStr | ellipsify:30}}</span> -->
    
                <span
                (click)="removeCompletedProducts(item)"
                style="
                margin-left: 20px;
                display: inline-block;
                cursor: pointer;">
                  Remove
                </span>
                </div>
  
            </div>
            <div class="second-div" style="padding: 0;">
  
              <div >
                <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                  <!-- <mat-label>Price</mat-label> -->
                  <input [(ngModel)]="item.product_price" matInput smDecimalOnly type="number"  (ngModelChange)="changeProductPrice(item)"/>
                  <!--  -->
                </mat-form-field>
              </div>
          </div>
  
          </div>
        </div>
          
  
        </div>
         <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other items</h3>
    </div>
    <!-- <div class="repect_under" *ngFor="let item of repeatArray; let i = index">
    <div class="row">
      <div class="col-sm-6">
        <div class="item_name_tht">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Item name</mat-label>
              <input matInput type="text" placeholder="Enter item name">
            </mat-form-field>
        </div>
      </div>

      <div class="col-sm-6">
        
        <div class="plus_tht" style="padding-top: 14px;">
          <mat-icon class="serv_x">close</mat-icon>
          <div class="inc_dec_cont">
            <span class="cont_span">
              <button class="inc_dec_btn">
              <mat-icon >remove</mat-icon>
              </button>
              <span style="margin: 0 15px;"> 1 </span>
              <button 
              class="inc_dec_btn">
              <mat-icon class="material-icons-outlined">add</mat-icon>
              </button>
            </span>
            <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
          </div>
        </div>

      </div>
    </div>
  </div>
 
    <div class="add_item_btbh">
      <button mat-flat-button color="accent" (click)="addFormField()">
        <mat-icon>add</mat-icon>
        Add item
      </button>
    </div> -->

    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="row" style="width: 100%;">
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="plus_tht" style="padding-top: 14px;">
                <mat-icon class="serv_x">close</mat-icon>
                <div class="inc_dec_cont">
                  <span class="cont_span">
                    <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              
              <mat-form-field appearance="outline" >
                <mat-select class="w-100" formControlName="tax_slab">
                  <mat-option value="default" >
                    Select a tax
                  </mat-option>
                  <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                    {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                  </mat-option>
                  
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item price</mat-label>
                  <input matInput formControlName="price" type="text" placeholder="Enter item price" smDecimalOnly type="number">
                </mat-form-field>
              </div>
            </div>
            <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
          </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button type="button" mat-flat-button color="accent" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


  <!-- create invice new design end -->



   
    <div style="border-bottom: 1px solid lightgray;">
        <div class="row" style="margin-bottom: 20px; padding: 0 18px 0 0">
            <div class="col-sm-10" style="font-size: 16px;">Total</div>
            <div class="col-sm-2" style="text-align: right; font-size: 16px;">
                <!-- <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                    <input [(ngModel)]="newbookingData.price" matInput smDecimalOnly type="number" />
                  </mat-form-field> -->
    
                  {{newbookingData.price.toFixed(2)}}
                </div>
         
        </div>
        <div class="open_table" style="margin-bottom: 20px; padding: 0 18px 0 0" *ngIf="this.customiseBookingData[0]?.coupon_code">
        <div class="discount_list" style="font-size: 16px;">Coupon discount</div>
        <div class="discount_list" style="text-align: right; font-size: 16px;">
           {{this.customiseBookingData[0]?.coupon_discount.toFixed(2)}}
        </div>
     </div>
        <div class="row" style="padding: 0 18px 0 0;">
            <div class="col-sm-10" style="font-size: 16px;">Discount</div>
            <div class="col-sm-2" style="text-align: right;">
                <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                    <input [(ngModel)]="newbookingData.discount" matInput smDecimalOnly type="number" (ngModelChange)="changedDiscountByBusiness($event)"/>
                  </mat-form-field>
                </div>
         
        </div>
       
    </div>

    <div>
        <div class="row" style="margin-top: 20px; margin-bottom: 40px; padding: 0 18px 0 0">
            <div class="col-sm-10" style="font-size: 16px;">Net payable</div>
            <div class="col-sm-2" style="text-align: right; font-size: 16px;">
                <!-- <mat-form-field appearance="outline" style="width: 100px" class="small-height-input">
                    <input [(ngModel)]="newbookingData.price" matInput smDecimalOnly type="number" />
                  </mat-form-field> -->
                {{(newbookingData.price - newbookingData.discount - customiseBookingData[0]?.coupon_discount).toFixed(2)}}
                </div>
         
        </div>
    </div>
   
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" *ngIf="!toShowEmployees">

    <button
    
    mat-button
    style="border: 1px solid #b48700;"
    (click)="allDoneAndRelease()"
  >
    All done and release
  </button>
    <button mat-button   style="border: 1px solid #b48700;" 
    
    (click)="partiallyDone()"
    >Save as under process</button>
   
    <button
    
      mat-flat-button
      color="accent"
      (click)="onPost()"
   
      
    >
      Continue and produce bill
    </button>
  </mat-dialog-actions>
  

  <!-- employee list -->

  <!-- <mat-dialog-content *ngIf="toShowEmployees">
    <div class="row" *ngIf="employeeList.length > 0">
      <div class="col-sm-6" *ngFor="let item of employeeList">
        <div class="fl_orders" (click)="selectEmployeeToAssign(item)">
          <div class="top_section_order">
            <div class="row">
              <div class="col-sm-3">
                <div class="ads_sec">
                  <div
                    class="hm_icon_progr"
                    *ngIf="item.imgThumbUrl && item.imgThumbUrl != 'null'"
                  >
                    <img [src]="item.imgThumbUrl" />
                  </div>
                  <div
                    class="hm_icon_progr"
                    *ngIf="
                      !item.imgThumbUrl || item.imgThumbUrl == 'null'
                    "
                  >
                    <img src="../../../../assets/images/user-avatar.svg" />
                  </div>
                </div>
              </div>
              <div class="col-sm-9" style="padding-left: 0px;">
                <div class="order_dec">
                  <div
                    class="tick_opklads"
                    [ngStyle]="{
                      background: item.selected ? '#1da942' : 'lightgrey'
                    }"
                  >
                    <mat-icon
                      class="material-icons-outlined"
                      class="mb-1"
                      style="color: #fff"
                      >check</mat-icon
                    >
                  </div>
                  <h3
                    style="
                      -webkit-box-orient: vertical;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: normal;
                    "
                  >
                    {{ item.name }}
                  </h3>
                  <p>{{ item.phone }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </mat-dialog-content>
  
  
  <mat-dialog-actions align="end" *ngIf="toShowEmployees">
    <button mat-button (click)="hideEmployee()">Cancel</button>
    <button
      [disabled]="employeeToAssign.length == 0"
      mat-flat-button
      color="accent"
      (click)="assignEmployee()"
    >
      Assign
    </button>
  </mat-dialog-actions>
   -->